import { browsingDomainStore } from '../../store';
import { getSitesByIds } from './get-sites-by-ids';
export const getUnselectedSites = () => {
    const unselectedSiteIds = Object.keys(browsingDomainStore.data.sitesById).filter(siteId => !browsingDomainStore.data.selectedSiteIds.includes(siteId));
    return getSitesByIds(unselectedSiteIds);
};
